import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { goBack } from "react-router-redux";
import { ProjectActionCreators, AppActionCreators } from "../../../actions";
import { ProjectType } from "../../../utils/enums";
import { RouteUrls } from "../../../configs/routeUrls";
import { PreviewProjectCardForm } from "../Project/PreviewProjectCardForm";

class ConsultationCardPreviewContainerBO extends Component {
  constructor(props) {
    super(props);
    this.onGoBack = this.onGoBack.bind(this);
  }

  componentDidMount() {
    let { id, clientId } = this.props.match.params;
    if (id) {
      this.props.getProject(id, clientId);
    }
    this.props.setBreadcrumbs([
      {
        url: RouteUrls.Consultation.list.actual,
        displayName: "Konsultacje",
      },
      {
        url: RouteUrls.Consultation.previewFunc(id),
        displayName: "Konsultacja",
      },
    ]);
  }

  onGoBack() {
    this.props.goBack();
  }

  render() {
    const { setExpandStateItem, expand } = this.props;
    return (
      <PreviewProjectCardForm
        {...this.props.project}
        consultationTitle="Konsultacja"
        disabled={true}
        isAuth={this.props.isAuth}
        loggedUserId={this.props.loggedUser.userId}
        loggedOfficeId={this.props.loggedUser.officeId}
        loggedUserIsCitizen={this.props.loggedUser.isCitizen}
        type={ProjectType.Consultation}
        addCommentOpinion={(id, type) => this.props.addCommentOpinion(id, type)}
        addProjectOpinion={(id, type) => this.props.addProjectOpinion(id, type)}
        onCancel={this.onGoBack}
        removeCommentOpinion={(id) => this.props.removeCommentOpinion(id)}
        removeProjectOpinion={(id) => this.props.removeProjectOpinion(id)}
        saveComment={(values) => this.props.saveComment(values)}
        isProjectLoading={this.props.isProjectLoading}
        opinionExecuting={this.props.opinionExecuting}
        voteExecuting={this.props.voteExecuting}
        isOnlyOneOffice={this.props.isOnlyOneOffice}
        onSetExpandStateItem={setExpandStateItem}
        expand={expand}
        isPreview={true}
      />
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    isProjectLoading: state.project.isProjectLoading,
    opinionExecuting: state.project.opinionExecuting,
    voteExecuting: state.project.voteExecuting,
    project: state.project.project,
    loggedUser: state.app.loggedUser,
    isAuth: state.app.isAuth,
    isOnlyOneOffice: state.app.offices && state.app.offices.length === 1,
    expand: state.app.expand,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    ...bindActionCreators(
      { ...ProjectActionCreators, ...AppActionCreators },
      dispatch
    ),
    ...{
      goBack: () => dispatch(goBack()),
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ConsultationCardPreviewContainerBO);
